export default __webpack_public_path__ + "static/media/sopTrashIcon_disabled.6b528381.svg";